var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66.57px",
    height: "66.56px",
    viewBox: "0 0 66.57 66.56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-1277.600000, -1944.660000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "translate(-0.060000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1277.66,1973.74 L1302.51,1973.74 L1302.51,1982.14 L1277.66,1982.14 L1277.66,1973.74 Z M1306.77,1973.74 L1315.17,1973.74 L1315.17,1982.14 L1306.77,1982.14 L1306.77,1973.74 Z M1331.99,1956.92 L1331.99,1965.33 L1323.58,1965.33 L1323.58,1956.92 L1331.99,1956.92 Z M1331.99,1998.95 L1323.58,1998.95 L1323.58,1990.55 L1331.99,1990.55 L1331.99,1998.95 Z M1289.95,1998.95 L1289.95,1990.55 L1298.36,1990.55 L1298.36,1998.95 L1289.95,1998.95 Z M1289.95,1956.92 L1298.36,1956.92 L1298.36,1965.33 L1289.95,1965.33 L1289.95,1956.92 Z M1306.74,2011.22 L1306.74,1986.37 L1315.15,1986.37 L1315.15,2011.22 L1306.74,2011.22 Z M1306.74,1969.51 L1306.74,1944.66 L1315.15,1944.66 L1315.15,1969.51 L1306.74,1969.51 Z",
    id: "Path_111",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_112",
    fill: "#BEB0FF",
    points: "1319.38 1973.74 1344.23 1973.74 1344.23 1982.14 1319.38 1982.14"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/Icon9.2088e65bae97e78b05ffbfc806d40326.svg";
export { ForwardRef as ReactComponent };